import React, {Component} from 'react';
import moment from 'moment';

interface Properties {
  orderData: LooseObject;
}

class Prices extends Component<Properties> {
  render(): JSX.Element {
    const {
      currentMembership,
      contract: {price, startDate},
      currentClub: {region},
    } = this.props.orderData.order;

    return (
      <div className="c-salesProcess__side">
        <div className="c-salesProcess__side__wrapper">
          {
            <div>
              <div>
                <div>
                  <h2>Total due today</h2>
                  <table>
                    <tbody>
                      <tr>
                        <td>current month</td>
                        <td>{price ? `${(price.proRataPrice || 0).toFixed(2)} ${currentMembership.currency}` : '-'}</td>
                      </tr>
                      <tr>
                        <td>Joining Pack</td>
                        <td>{price ? `${(price.joiningFeePrice || 0).toFixed(2)} ${currentMembership.currency}` : '-'}</td>
                      </tr>
                      {price.deposit && (
                        <tr>
                          <td>Advanced Payment</td>
                          <td>{price ? `${(price.deposit || 0).toFixed(2)} ${currentMembership.currency}` : '-'}</td>
                        </tr>
                      )}

                      <tr>
                        <td>total</td>
                        <td>{price ? `${(price.totalAmount || 0).toFixed(2)} ${currentMembership.currency}` : '-'}</td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <h2>Future payments</h2>
                  <table>
                    <tbody>
                      {(Number.isInteger(price.startupCampaignPrice) || price.startupCampaignPrice) && price.startupCampaignEndDate && (
                        <tr>
                          <td>
                            <strong>
                              Special offer (
                              {moment(startDate)
                                .add(1, 'month')
                                .startOf('month')
                                .format(region.id === 8 || region.id === 9 ? 'DD/MM' : 'DD.MM')}{' '}
                              - {price.startupCampaignEndDate && moment(price.startupCampaignEndDate).format(region.id === 8 || region.id === 9 ? 'DD/MM/YYYY' : 'DD.MM.YYYY')})
                            </strong>
                          </td>
                          <td>
                            <strong>{price ? `${price.startupCampaignPrice.toFixed(2)} ${currentMembership.currency}` : '-'}</strong>
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td>Monthly Fee</td>
                        <td>{price ? `${(price.normalPeriodPrice || 0).toFixed(2)} ${currentMembership.currency}` : '-'}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

export default Prices;



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/components/ListOrders/components/ListOrders/components/General/components/Prices/Prices.tsx